/** Per-tool SEO content - localized to the active language toggle. */

import { useLocale } from "@/hooks/use-locale";
import { getToolSeo, localizeTool, buildToolSchema, type Locale } from "@/seo/seo.config";
import SeoArticle from "./SeoArticle";

const ToolSeoContent = ({ toolId }: { toolId: string }) => {
  const { locale } = useLocale();
  const seo = getToolSeo(toolId);
  if (!seo) return null;
  const c = localizeTool(seo, locale as Locale);
  return <SeoArticle {...c} locale={locale as Locale} schema={buildToolSchema(c, seo.slug)} />;
};

export default ToolSeoContent;
